import * as React from 'react';

export interface ITooltipProps {
    className?: string;
    // if the tooltip is not centered horizontally, this prop can be used
    // the value should be half of the width of the tooltip (min: 100, max: 150)
    offsetX?: number;
    children: JSX.Element;
    tooltipMessage: string;
}

// this component can be extended depending on the new usages
export const Tooltip: React.SFC<ITooltipProps> = (props: ITooltipProps) => {
    return (
        <div className={"simple-tooltip " + props.className}>
            {props.children}
            <span className="simple-tooltip-text" style={props.offsetX ? {marginLeft: -props.offsetX} : {}}>
                {props.tooltipMessage}
            </span>
        </div>
    );
};

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/Tooltip.tsx